export default __webpack_public_path__ + "static/drukarka-e1f010c41ed1a01077dbad7b0ecfa787.png";